<template>
  <div class="dock-five-six w100 flex flex-dir--top h100">
    <breadcrumb
      :title="$route.query.line || $t('main.head.produceLine')"
      :childTitle="$t('doorWallCabinet.title')"
      @goBackPage="goBackPage"
    >
      <div v-if="!previewInfo.isPreview">
        <a-button
          @click.native="handleOpenChangeRecord"
          id="equipment_five_six_change_record"
          class="mr20"
        >
          修改记录
        </a-button>
        <a-button
          @click.native="saveDockFiveSix"
          :disabled="!ableSaveSetting"
          type="primary"
          id="equipment_setting_save_btn"
          ><a-icon type="save" />{{ $t('common.saveSetting') }}</a-button
        >
      </div>
      <div v-if="previewInfo.isApply">
        <a-button
          @click.native="saveDockFiveSix"
          :disabled="!ableSaveSetting"
          type="primary"
          id="equipment_setting_save_btn"
          ><a-icon type="save" />应用设置</a-button
        >
      </div>
    </breadcrumb>
    <div class="wrap pb20 h100 y-auto">
      <div>
        <div class="file-format">
          <span id="span_bcn1udjhon" class="head-title">{{
            $t('dock56Drill.fileType')
          }}</span>
          <div class="content flex">
            <div class="relative">
              <span id="span_qfcd8wscc2" class="small-title"
                >{{ $t('dock56Drill.fileType') }}：</span
              >
              <a-select
                :disabled="dock56FDrill_customFile"
                style="width: 330px"
                :getPopupContainer="
                  (triggerNode) => {
                    return triggerNode.parentNode || document.body
                  }
                "
                :filter-option="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .trim()
                      .includes(input.toLowerCase())
                "
                show-search
                v-model="selectedDockFile"
                showArrow
                @change="changeSelectedDockFile"
                id="fiveSix_setting_dockFile_select"
              >
                <!-- default-value="xml" -->
                <a-select-option
                  :value="item.door56Format"
                  v-for="(item, index) in dockFiveSixList"
                  :key="index"
                  :title="item.modelName"
                  :id="`fiveSix_setting_dockFile_select_option_${index}`"
                  >{{ item.modelName }}</a-select-option
                >
              </a-select>
              <span
                id="span_7w84yfqfjv"
                v-if="isNotOnline"
                class="not-online"
                >{{ $t('dock56Drill.templateOffline') }}</span
              >
              <div
                id="div_4pv2979w8i"
                v-if="showFiveSixDefault"
                class="tip mt8"
              >
                当前模板对于部分孔槽分流功能不生效，推荐使用自定义模板
              </div>
              <div class="mt20">
                <span id="span_re3ttm70vl" class="small-title"
                  >{{ $t('dock56Drill.showExample') }}：</span
                >
                <a-checkbox
                  v-model="showSample"
                  id="fiveSix_setting_showSample_checkbox"
                  v-bp:change="'dock56f:showSample'"
                ></a-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div class="common-setting" v-show="showSample">
          <span id="span_a2ss4v247m" class="head-title">{{
            $t('dock56Drill.example')
          }}</span>
          <div class="content">
            <DockFiveSixSample
              :file-type="selectedDockFile || ''"
              :isDoorWallAio="true"
            />
          </div>
        </div>
        <div class="common-setting">
          <span id="span_1sl9vukru9" class="head-title">{{
            $t('dock56Drill.commonSetting')
          }}</span>
          <div class="content">
            <span id="span_7rfrpnsyke" class="small-title"
              >{{ $t('dock56Drill.throughSlotSetting') }}：</span
            >
            <a-checkbox
              v-model="dock56FDrill_twoSideConSlot"
              id="fiveSix_setting_towSideConSlot_checkbox"
            ></a-checkbox>
          </div>
          <div class="content">
            <span id="span_crb71w14xz" class="small-title"
              >{{ $t('dock56Drill.arcDescription') }}：</span
            >
            <a-radio-group v-model="arc_description">
              <a-radio
                value="line_points"
                id="fiveSix_setting_arc_description_line_points_radio"
                ><span
                  id="fiveSix_setting_arc_description_line_points_radio_label"
                  >{{ $t('dock56Drill.linePoints') }}</span
                ></a-radio
              >
              <a-radio
                value="arc_command"
                id="fiveSix_setting_arc_description_arc_command_radio"
                ><span
                  id="fiveSix_setting_arc_description_arc_command_radio_label"
                  >{{ $t('dock56Drill.arcCommand') }}</span
                ></a-radio
              >
            </a-radio-group>
          </div>
          <div class="content">
            <span id="span_j0gpeywor5" class="small-title">{{
              $t('dock56Drill.slotWidthSplit')
            }}</span>
            <a-checkbox
              v-model="split_slot"
              id="fiveSix_setting_split_slot_checkbox"
            ></a-checkbox>
            <span id="span_p3p4mpy98w" class="small-title partition">{{
              $t('dock56Drill.slotSplitWidth')
            }}</span>
            <a-input
              v-model="single_width"
              @change="changeSingleWidth(single_width)"
              id="fiveSix_setting_single_width_input"
            ></a-input>
            <span id="span_1kwla7foly" class="partition hintColor">{{
              $t('dock56Drill.mm')
            }}</span>
            <img
              :src="require('@/assets/banlu_dismantle.png')"
              alt="无法加载"
              class="partition"
            />
          </div>

          <!-- 槽长度补偿 -->
          <div class="content slot-compensation-content">
            <span id="span_i13ob0ukul" class="small-title"
              >{{ $translateLang('槽长度补偿') }}：</span
            >
            <div>
              <div class="item">
                <span id="span_b0uiamkz5v"
                  >{{ $translateLang('距边为0的槽边补偿') }}:</span
                >
                <a-input
                  :value="slotEdge0Comp"
                  id="fiveSix_setting_slotEdge0Comp_input"
                  class="item-input"
                  suffix="mm"
                  @input="(e) => formatInputValue('slotEdge0Comp', e)"
                  @blur="handleBlurAddBurypoint('slotEdge0Comp')"
                >
                </a-input>
                <span id="span_nv5otqwb9s"
                  >({{
                    $translateLang(
                      '加工出现未切干净的小圆角或长度不够时使用此功能'
                    )
                  }})</span
                >
              </div>
              <div class="item">
                <span id="span_tixf0cblaq"
                  >{{ $translateLang('距边不为0的槽边补偿') }}:</span
                >
                <a-input
                  :value="slotNoEdge0Comp"
                  id="fiveSix_setting_slotNoEdge0Comp_input"
                  class="item-input"
                  suffix="mm"
                  @input="(e) => formatInputValue('slotNoEdge0Comp', e)"
                  @blur="handleBlurAddBurypoint('slotNoEdge0Comp')"
                ></a-input>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <m-lock-modal
      :visible.sync="isShowVisible"
      :status.sync="lockStatus"
      :tempStatus.sync="tempStatus"
      :verifyPassword="verifyPassword"
      :lineName="$route.query.line"
      codeType="bluen_update_production"
      @getLockPassword="handleGetLockPassword"
      @handleChangePasswordState="handleChangePasswordState"
    ></m-lock-modal>
    <!-- 修改记录弹窗 -->
    <m-change-record-modal
      :visible.sync="showRecordModal"
      operate_equipment="dock56FDrill"
      @success="handleSuccess"
      ref="recordModalRef"
    />
  </div>
</template>

<script>
import { buryPoint } from '@/apis/common/buryPoint'
import {
  getDoorWallAioList,
  getDoorWallAioSetting,
  saveDoorWallAioSetting,
} from '@/apis/doorWallAioSetting'
import { getLockStatus } from '@/apis/productionLineLock'
import { Navigate } from '@/components/g-search/utils'
import breadcrumb from '@/components/topBreadCrumb.vue'
import store from '@/store'
import {
  genFinalRecord,
  genFinalRecordPromise,
  verifyInputNumber,
} from '@/util/commonFuncs'
import {
  dockFiveSixFormTextObj,
  dockFiveSixFormValueObj,
} from '@/util/operateRecordConfigure/dockFiveSixConfigure'
import { saveDataJsonToOssForRecord } from '@/util/saveFile'
import MChangeRecordModal from '@/views/equipment/component/m-change-record-modal.vue'
import MLockModal from '@/views/equipment/component/m-lock-modal.vue'
import { mapState } from 'vuex'

import DockFiveSixSample from './component/dockFiveSixSample.vue'

export default {
  components: {
    breadcrumb,
    DockFiveSixSample,
    MLockModal,
    MChangeRecordModal,
  },
  data() {
    return {
      lockStatus: 1, // 锁状态
      verifyPassword: true,
      tempStatus: 1, //默认状态
      isShowVisible: false,
      // 是否使用文件自定义
      dock56FDrill_customFile: false,
      // 是否为天工
      showTiangong: false,
      // 记录选择的五六面钻文件
      selectedDockFile: '',
      // 记录五六面钻的文件类型
      dockFiveSixList: [],
      // 通槽分双面打通
      dock56FDrill_twoSideConSlot: false,
      // 圆弧描述方式
      arc_description: 'arc_command',
      // 宽槽拆解为多条窄槽加工
      split_slot: true,
      // 拆解后单条槽宽度
      single_width: '',
      /**距边为0的槽长度补偿 */
      slotEdge0Comp: 0,
      /**距边不为0的槽宽度补偿 */
      slotNoEdge0Comp: 0,

      // 记录是否可以进行保存
      ableSaveSetting: false,
      // 记录当前五六面钻模板是否被下线
      isNotOnline: false,
      oriFormData: {},
      // 是否显示样例
      showSample: false,
      showRecordModal: false,
    }
  },
  methods: {
    handleOpenFileManage() {
      this.$router.push({
        path: '/fileManage',
      })
    },
    verifyInputNumber(
      val,
      verifyObj,
      keys,
      rule,
      isMinus = false,
      min = 0,
      isEmpty = false,
      max = 0
    ) {
      verifyInputNumber(val, verifyObj, keys, rule, isMinus, min, isEmpty, max)
    },
    getPopupContainer(triggerNode) {
      return triggerNode.parentElement || document.body
    },
    async handleGetLockPassword() {
      await this.saveDockFiveSix()
    },
    handleChangePasswordState(state) {
      this.verifyPassword = state
    },
    changeSingleWidth(value) {
      this.single_width = value
        .replace(/\D*(\d{0,3})\d*(\.?)(\d{0,3})\d*/, '$1$2$3')
        .replace(/[^\d\.]/g, '')
    },
    toCustomFile() {
      this.$router.push({
        path: '/customFile',
        query: {
          setting_id: this.$route.query.setting_id,
          line: this.$route.query.line,
        },
      })
    },
    goBackPage() {
      this.nowPath = ''
      let path = ''
      if (this.showTiangong) {
        path = '/equipment?from=tiangong'
      } else {
        path = '/equipment'
      }
      if (this.previewInfo.isPreview) {
        path = `${path}-preview`
      }

      this.$router.push(path)
    },
    // 输入检测
    // inputCheck(val){
    //   // this[val] = this[val].replace(/[^\d]/g, "") // 去除数字和小数点以外的数字
    // },
    // 修改选择的文件格式时, 更改状态
    changeSelectedDockFile() {
      if (this.isNotOnline && this.selectedDockFile != '') {
        this.isNotOnline = false
      }
    },
    genCompareData(current, ori) {
      const dockFiveSixFormValueObjTemp = {
        ...dockFiveSixFormValueObj,
      }
      const compareMsg = [
        {
          title: '生成文件类型',
          keys: ['selectedDockFile'],
        },
        {
          title: '通用参数设置',
          keys: [
            'dock56FDrill_twoSideConSlot',
            'arc_description',
            'split_slot',
            'single_width',
            'slotEdge0Comp',
            'slotNoEdge0Comp',
          ],
        },
      ]
      return {
        type: 'form',
        current, // 当前表单数据
        ori, // 原始表单数据
        compareMsg, // 要比较的内容
        formTextObj: dockFiveSixFormTextObj, // key对应的意思
        formValueObj: dockFiveSixFormValueObjTemp, // value对应的意思
      }
    },
    async genFinalRecordFn(current, ori, saveData, callback = null) {
      let recordData = {
        key: '门墙柜一体机', // 操作记录最外层的名字，比如：雕刻机
        operateArr: [
          // 应对多个操作页面时，比如雕刻机的操作页面
          {
            key: '',
            dataArr: [
              // 表单对比
              this.genCompareData(current, ori),
            ],
          },
        ],
      }
      // genFinalRecord(recordData, 'equipment_docking', () => {
      //   if (this.$route.query.setting_id) {
      //     this.getAllDock56File()
      //   }
      // })
      try {
        const res = await genFinalRecordPromise(recordData, 'equipment_docking')
        if (res) {
          const { record, finalId, action_type } = res
          saveDataJsonToOssForRecord(
            record,
            action_type,
            {
              id: finalId,
              operate_equipment: 'dock56FDrill',
              save_data: saveData,
              setting_id: this.$route.query.setting_id,
              operatorPhone: this.previewInfo.operatorPhone,
            },
            () => {
              if (!this.previewInfo?.isApply) {
                this.getAllDock56File()
              }
              callback && callback()
            }
          )
        }
      } catch (error) {
        this.$message({
          message: '生成操作记录失败',
          type: 'error',
        })
      }
    },
    // 保存五六面钻设置
    saveDockFiveSix() {
      // 判断锁定状态，打开弹窗
      // 根据获取的状态 锁定状态
      this.lockStatus = this.tempStatus
      let formData = {
        dock56FDrill_twoSideConSlot: this.dock56FDrill_twoSideConSlot,
        arc_description: this.arc_description,
        split_slot: this.split_slot,
        single_width: this.single_width,
        slotEdge0Comp: this.slotEdge0Comp,
        slotNoEdge0Comp: this.slotNoEdge0Comp,
      }
      formData.fileType = this.selectedDockFile
      let data = {
        setting_id: this.$route.query.setting_id,
        data: formData,
        ...store.state.saveInfo,
        platform: 'bluen',
      }
      this.ableSaveSetting = false
      this.$store.commit('setCurrentProductLineName', this.$route.query.line)
      saveDoorWallAioSetting(data).then((res) => {
        this.ableSaveSetting = true
        if (res.status == 1) {
          this.isShowVisible = false
          this.$message({
            message: this.$t('common.saveSuccess'),
            type: 'success',
            duration: 1500,
            offset: 70,
          })
          try {
            this.genFinalRecordFn(
              {
                ...formData,
                selectedDockFile: this.selectedDockFile,
              },
              this.oriFormData,
              data
            )
          } catch (error) {
            console.error('error', error)
          }
          if (res.data.phone && res.data.request_ip) {
            let recordData = {
              key: '保存设置',
              operateArr: [
                {
                  key: '生产线设置',
                  dataArr: [
                    {
                      type: 'form',
                      current: {
                        phone: res.data.phone,
                        time: new Date().toLocaleString(),
                        id: store.state.userInfo.id,
                        ip: res.data.request_ip,
                      },
                      ori: {
                        phone: '',
                        time: '',
                        id: '',
                        ip: '',
                      },
                      compareMsg: [
                        {
                          title: '',
                          keys: ['phone', 'time', 'id', 'ip'],
                        },
                      ],
                      formTextObj: {
                        phone: '手机号',
                        time: '保存时间',
                        id: '用户id',
                        ip: '物理地址',
                      },
                      formValueObj: {},
                    },
                  ],
                },
              ],
            }
            genFinalRecord(recordData, 'equipment_docking', '', () => {})
          }
        } else if (res.status == -1) {
          if (store.state.saveInfo.phone) {
            this.$message({
              message: res.msg,
              type: 'error',
              duration: 1500,
              offset: 70,
            })
          }
          this.showSaveModal()
        } else {
          this.$message({
            message: res?.msg || this.$t('lineManager.permissionTip'),
            type: 'error',
            duration: 1500,
            offset: 70,
          })
        }
        store.commit('setSaveInfo', {})
      })
    },
    showSaveModal() {
      this.lockStatus = this.tempStatus
      this.verifyPassword = true
      this.isShowVisible = true
      return
    },
    // 生成formData
    genOriFormData(res) {
      this.oriFormData = {
        selectedDockFile: this.selectedDockFile,
        dock56FDrill_twoSideConSlot: this.dock56FDrill_twoSideConSlot,
        arc_description: this.arc_description,
        split_slot: this.split_slot,
        single_width: this.single_width,
        slotEdge0Comp: this.slotEdge0Comp,
        slotNoEdge0Comp: this.slotNoEdge0Comp,
      }
    },
    // 读取五六面钻所有文件
    getAllDock56File() {
      getDoorWallAioList({ from: 'user' }).then((res) => {
        if (res.status == 1) {
          this.dockFiveSixList = res.data.model_list
          this.getDockFiveSix(this.$route.query.setting_id)
        }
      })
      // this.$get(
      //   '/dock56F_list',
      //   {
      //     from: 'user',
      //   },
      //   (res) => {
      //     if (res.status == 1) {
      //       this.dockFiveSixList = res.data.model_list
      //       this.getDockFiveSix(this.$route.query.setting_id)
      //     }
      //   }
      // )
    },
    // 读取五六面钻设置
    getDockFiveSix(id) {
      getDoorWallAioSetting({ setting_id: id }).then((res) => {
        if (res.status == 1) {
          this.dealWithFiveSixSetting(res)
          this.genOriFormData(res)
          // 后台应用生产线时进入
          if (this.previewProductLine?.dock56) {
            this.dealWithFiveSixSetting({
              data: this.previewProductLine?.dock56,
            })
          }
        } else {
          this.$message({
            type: 'info',
            message: this.$t('dock56Drill.permissionErr'),
            duration: 1500,
            offset: 70,
          })
        }
      })
      // this.$get(
      //   '/load_dock56F_setting',
      //   {
      //     setting_id: id,
      //   },
      //   (res) => {
      //     if (res.status == 1) {
      //       this.dealWithFiveSixSetting(res)
      //       this.genOriFormData(res)
      //       // 后台应用生产线时进入
      //       if (this.previewProductLine?.dock56) {
      //         this.dealWithFiveSixSetting({
      //           data: this.previewProductLine?.dock56,
      //         })
      //       }
      //     } else {
      //       this.$message({
      //         type: 'info',
      //         message: this.$t('dock56Drill.permissionErr'),
      //         duration: 1500,
      //         offset: 70,
      //       })
      //     }
      //   }
      // )
    },
    handleGetLockStatus() {
      //TODO 进入页面，获取生产线设置锁的状态
      getLockStatus().then((res) => {
        // 拿到的锁状态赋值，当前是锁定还是解锁状态
        this.lockStatus = res?.data?.is_lock || 0
        this.tempStatus = res?.data?.is_lock || 0
      })
    },
    // 打开修改记录弹窗
    handleOpenChangeRecord() {
      this.showRecordModal = true
    },
    // 还原参数后的回调
    handleSuccess(newData) {
      const { data } = newData
      this.genFinalRecordFn(
        {
          ...data,
          selectedDockFile: data.fileType,
        },
        this.oriFormData,
        newData,
        () => {
          this.$refs['recordModalRef']?.getData({ isReset: true })
        }
      )
    },

    // 初始化处理五六面钻设置
    dealWithFiveSixSetting(res) {
      this.ableSaveSetting = true
      this.dock56FDrill_twoSideConSlot = res.data.dock56FDrill_twoSideConSlot
      this.dock56FDrill_customFile = false
      const selectedDockFile = res.data.fileType
      console.log('selectedDockFile', selectedDockFile)
      console.log('this.dockFiveSixList', this.dockFiveSixList)
      let data = this.dockFiveSixList.find(
        (v) => v.door56Format == selectedDockFile
      )
      if (!data) {
        this.isNotOnline = true
        this.selectedDockFile = ''
        this.$message({
          message: this.$t('dock56Drill.fileTypeOffline'),
          type: 'info',
        })
      } else {
        this.selectedDockFile = selectedDockFile
      }
      ;(this.arc_description = res.data.arc_description),
        (this.split_slot = res.data.split_slot),
        (this.single_width = res.data.single_width)
      this.slotEdge0Comp = res.data.slotEdge0Comp
      this.slotNoEdge0Comp = res.data.slotNoEdge0Comp
    },

    // 输入值格式化
    formatInputValue(key, e) {
      // 使用正则判断输入的是否是正数，并且最多只能有两位小数，不能以0开头(除了0本身)
      const reg = /^([1-9]\d{0,4}|0)(\.\d{1,2})?$/
      const value = e.target.value
      if (value === '') return (this[key] = 0)

      if (reg.test(value)) this[key] = Number(value)
    },

    // 输入框失焦时，添加操作埋点
    handleBlurAddBurypoint(key) {
      buryPoint({ function_module: 'dock56f', function_point: key })
    },
  },
  computed: {
    ...mapState('equipEnvironment', ['previewProductLine', 'previewInfo']),
    // 是否选中默认模板
    showFiveSixDefault() {
      return ['xml2', 'mpr', 'dxf', 'ban'].includes(this.selectedDockFile)
    },
  },
  mounted() {
    this.handleGetLockStatus()
    if (this.$route.query.from) {
      if (this.$route.query.from == 'tiangong') {
        this.showTiangong = true
      }
    } else {
      this.showTiangong = false
      if (this.$route.query) {
        if (this.$route.query.setting_id) {
          this.getAllDock56File()
        }
      }
    }
    Navigate.getInstance().registerEvent(this.$route.path, {
      waitLoadDone: () => (this.ableSaveSetting ? 1 : 0),
    })
  },
  beforeDestroy() {
    Navigate.getInstance().unregisterEvent('/dockFiveSix')
  },
}
</script>

<style scoped lang="less">
/deep/.el-input {
  width: 50px;
}
.dock-five-six {
  .wrap {
    margin: 16px;
    overflow-y: auto;
    background: #fff;
    .equip-type {
      position: relative;
      .content {
        box-sizing: border-box;
        padding: 24px 24px 0 24px;
      }
      .content-level {
        padding-left: 50px;
      }
      .useCustomFileSet {
        position: absolute;
        top: 10px;
        right: 40px;
      }
      .toCustomFile {
        position: absolute;
        top: 10px;
        right: 20px;
        color: #18a8c7;
        cursor: pointer;
      }
    }
    .file-format {
      .content {
        box-sizing: border-box;
        padding: 24px 24px 0 24px;
        .ant-select {
          width: 190px;
        }
      }
      .content-level {
        padding-left: 50px;
      }
      .not-online {
        margin-left: 16px;
        color: #f00;
        font-size: 14px;
      }
    }
    .common-setting {
      .content {
        padding: 24px 24px 0 24px;
        .ant-input {
          width: 80px;
        }
        .partition {
          margin-left: 15px;
        }
        .slot-tuglie {
          width: 380px;
        }
        .hintColor {
          color: #f00;
        }
        .check {
          margin: 0 20px 0 10px;
        }
        .drill-slot-dir {
          margin-left: 270px;
        }
        &.shape-texdir {
          .ant-radio-group .ant-radio-wrapper {
            margin-right: 85px;
          }
          .ant-radio-group .ant-radio-wrapper:first-child {
            margin-right: 0px;
          }
        }
        .fiveSix_externalCutting_checkbox {
          margin-right: 10px;
        }
      }
      .content-level {
        padding-left: 50px;
      }
      .slot-compensation-content {
        display: flex;
        align-items: baseline;
        .item {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          .item-input {
            width: 120px;
            margin: 0 10px;
          }
        }
      }
    }
    .general-box {
      .content {
        padding: 24px 24px 0 24px;
        .small-title {
          width: 220px;
        }
      }
    }
  }
}
.tip {
  color: #f00;
}
</style>
